import React, { ElementType, FC } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
// material-ui
import { FormControl, FormHelperText, IconButton, Stack } from '@mui/material';
// libs
import { getIn } from 'formik';
import NumericFormatCustom from 'components/Form/Input/components/NumericFormat';
import { StyledTextField } from 'components/Form/Input/styled';
// types
import { InputBaseProps } from 'components/Form/Input/types';
import { StyledFormLabel } from 'components/Form/styled';

const Input: FC<InputBaseProps> = ({
  disabled,
  multiline,
  placeholder,
  label,
  rows = 4,
  InputProps,
  helperText,
  type,
  field,
  form,
  isRequired,
  inputProps,
  isMoney = false,
  disableClear = false,
  ...rest
}) => {
  const { errors, touched } = form;
  const errorMessage = getIn(errors, field.name);
  const isError = errorMessage && getIn(touched, field.name);

  const handleClearClick = () => {
    form.setFieldValue(field.name, '');
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement> | { target: { name: string; value: string } }) => {
    const value = 'value' in event.target ? event.target.value : '';
    form.setFieldValue(field.name, value);
  };
  
  const placeHolder = () => {
    //
  }

  return (
    <FormControl fullWidth>
      {label && <StyledFormLabel required={isRequired}>{label}</StyledFormLabel>}

      <StyledTextField
        {...field}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        multiline={multiline}
        rows={multiline && rows}
        onChange={handleInputChange}
        InputProps={{
          ...InputProps,
          inputComponent: isMoney ? NumericFormatCustom as ElementType : undefined,
          endAdornment: (
            <Stack direction={'row'} alignItems={'center'}>
              <IconButton
                sx={{ visibility: !disabled && field.value ? 'visible' : 'hidden' }}
                onClick={!disableClear ? handleClearClick : placeHolder}
              >
                <ClearIcon fontSize={'small'} />
              </IconButton>

              {InputProps?.endAdornment}
            </Stack>
          ),
        }}
        inputProps={{
          autoComplete: 'off',
          form: {
            autoComplete: 'off',
          },
          ...inputProps,
        }}
        size='small'
        variant='outlined'
        error={isError}
        helperText={isError && errorMessage}
        {...rest}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Input;